export enum NajizImpersonationProvidersEnum {
  Null = 'NULL',
  OrganizationActivation = 'organization-activation',
  NajizCenter = 'najiz-center',
  Lawyers = 'lawyers',
}


